(() => {
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => Array.from(root.querySelectorAll(s));
  const money = (cents) => {
    const currency = window.sellifeUpsellCurrency || 'USD';
    const locale = document.documentElement.lang || 'en';
    try { return new Intl.NumberFormat(locale,{style:'currency',currency}).format((Number(cents)||0)/100); }
    catch(e){ return ((Number(cents)||0)/100).toFixed(2)+' '+currency; }
  };
  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));

  const api = {
    pendingState:null, cartNotification:null, modal:null,
    canOpen(){
      return false;
    },
    async open({productId,parsedState,cartNotification}){
      this.pendingState=parsedState; this.cartNotification=cartNotification; this.modal=qs('[data-sellife-upsell-modal]');
      if(!this.modal) return this.finish();
      const loading=qs('[data-sellife-upsell-loading]',this.modal), wrap=qs('[data-sellife-upsell-products]',this.modal);
      loading.style.display=''; wrap.innerHTML=''; this.modal.classList.add('is-open'); this.modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden';
      let products=[];
      try{
        const root=window.Shopify?.routes?.root||'/';
        let res=await fetch(root+'recommendations/products.json?product_id='+encodeURIComponent(productId)+'&limit=6&intent=complementary');
        let data=await res.json(); products=data.products||[];
        if(!products.length){res=await fetch(root+'recommendations/products.json?product_id='+encodeURIComponent(productId)+'&limit=6&intent=related');data=await res.json();products=data.products||[];}
      }catch(e){products=[];}
      products=products.filter(p=>p&&p.available&&p.handle!=='sellife-order-protection'&&Array.isArray(p.variants)).map(p=>{const v=p.variants.find(v=>v.available);return v?{...p,sellifeVariant:v}:null;}).filter(Boolean).slice(0,5);
      if(!products.length) return this.finish();
      loading.style.display='none';
      wrap.innerHTML=products.map(p=>{const v=p.sellifeVariant;const image=typeof p.featured_image==='string'?p.featured_image:(p.featured_image?.url||'');const compare=Number(v.compare_at_price||0);const price=Number(v.price||p.price||0);return '<div class="sellife-upsell__item" data-upsell-row data-upsell-row-clickable data-variant-id="'+esc(v.id)+'"><div class="sellife-upsell__image">'+(image?'<img src="'+esc(image)+'&width=160" alt="'+esc(p.title)+'" loading="lazy">':'')+'</div><div><div class="sellife-upsell__name">'+esc(p.title)+'</div><div class="sellife-upsell__meta"><div class="sellife-upsell__qty"><button type="button" data-upsell-minus aria-label="Decrease">−</button><span data-upsell-qty>1</span><button type="button" data-upsell-plus aria-label="Increase">+</button></div></div></div><div class="sellife-upsell__price">'+(compare>price?'<span class="sellife-upsell__compare">'+money(compare)+'</span>':'')+money(price)+'<input class="sellife-upsell__select" type="checkbox" data-upsell-select aria-label="'+esc(p.title)+'"></div></div>';}).join('');
      qs('[data-sellife-upsell-close]',this.modal)?.focus();
    },
    close(){if(!this.modal)return;this.modal.classList.remove('is-open');this.modal.setAttribute('aria-hidden','true');document.body.style.overflow='';},
    finish(state=null){this.close();const finalState=state||this.pendingState;if(this.cartNotification&&finalState)this.cartNotification.renderContents(finalState);this.pendingState=null;},
    async addSelected(){
      if(!this.modal)return this.finish();
      const items=qsa('[data-upsell-row]',this.modal).filter(row=>qs('[data-upsell-select]',row)?.checked).map(row=>({id:Number(row.dataset.variantId),quantity:Number(qs('[data-upsell-qty]',row)?.textContent||1)}));
      if(!items.length)return this.finish();
      const button=qs('[data-sellife-upsell-add]',this.modal);button?.setAttribute('disabled','disabled');
      try{
        const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items,sections:['mini-cart-drawer','cart-notification-count'],sections_url:window.location.pathname})});
        const state=await response.json();this.finish(state?.sections?state:null);
      }catch(e){this.finish();}finally{button?.removeAttribute('disabled');}
    }
  };

  window.SellifeUpsell=api;

  document.addEventListener('click',event=>{
    if(event.target.closest('[data-sellife-upsell-close]')){event.preventDefault();api.finish();return;}
    if(event.target.closest('[data-sellife-upsell-add]')){event.preventDefault();api.addSelected();return;}
    const row=event.target.closest('[data-upsell-row]');
    if(row&&event.target.closest('[data-upsell-plus], [data-upsell-minus]')){const qtyEl=qs('[data-upsell-qty]',row);let qty=Number(qtyEl.textContent||1);qty=event.target.closest('[data-upsell-plus]')?Math.min(qty+1,10):Math.max(qty-1,1);qtyEl.textContent=qty;return;}
    if(row){
      const checkbox=qs('[data-upsell-select]',row);
      if(!checkbox)return;
      if(event.target!==checkbox){
        checkbox.checked=!checkbox.checked;
        checkbox.dispatchEvent(new Event('change',{bubbles:true}));
      }
      row.classList.toggle('is-selected',checkbox.checked);
    }
  });

  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&api.modal?.classList.contains('is-open'))api.finish();
  });

  document.addEventListener('change',async event=>{
    const upsellSelect=event.target.closest('[data-upsell-select]');
    if(upsellSelect){
      upsellSelect.closest('[data-upsell-row]')?.classList.toggle('is-selected',upsellSelect.checked);
      return;
    }

    const toggle=event.target.closest('[data-sellife-protection-toggle]');
    if(!toggle)return;

    const box=toggle.closest('.sellife-order-protection');
    if(box?.classList.contains('is-loading'))return;

    const desired=toggle.checked;
    const variantId=Number(toggle.dataset.variantId);
    const lineIndex=Number(toggle.dataset.lineIndex || 0);
    box?.classList.toggle('is-selected',desired);
    box?.classList.add('is-loading');

    try{
      let response;

      if(desired && lineIndex===0){
        response=await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({
            items:[{id:variantId,quantity:1}],
            sections:['mini-cart-drawer','cart-notification-count'],
            sections_url:window.location.pathname
          })
        });
      }else if(desired && lineIndex>0){
        response=await fetch('/cart/change.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({
            line:lineIndex,
            quantity:1,
            sections:['mini-cart-drawer','cart-notification-count'],
            sections_url:window.location.pathname
          })
        });
      }else if(!desired && lineIndex>0){
        response=await fetch('/cart/change.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({
            line:lineIndex,
            quantity:0,
            sections:['mini-cart-drawer','cart-notification-count'],
            sections_url:window.location.pathname
          })
        });
      }else{
        box?.classList.remove('is-loading');
        return;
      }

      if(!response.ok)throw new Error('Protection cart update failed');

      const state=await response.json();
      const cartNotification=qs('cart-notification');
      if(cartNotification&&state?.sections){
        cartNotification.renderContents(state);
      }
    }catch(e){
      toggle.checked=!desired;
      box?.classList.toggle('is-selected',!desired);
      box?.classList.remove('is-loading');
    }
  });
})();
